<template>
  <article class="upload-management">
    <Button class="top-create--btn" type="primary" @click="showUploadModal">{{ $t('upload.createFile') }}</Button>
    <Table :loading="loading" :columns="tableColumn" :data="fileList"></Table>
    <UploadFileModal :modalVisible.sync="uploadModalVisible" :isSupportCustom="true" @reload="getFileList" />
  </article>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import { getUploadFiles, deleteUploadFile } from '@/api/upload'
import UploadFileModal from './UploadFileModal.vue'

export default {
  name: 'UploadManagement',

  mixins: [nodeID],

  components: { UploadFileModal },

  data() {
    return {
      loading: false,
      fileList: [],
      tableColumn: [
        {
          title: this.$t('common.name'),
          key: 'name',
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                <a href="javascript:;">
                  <Poptip
                    confirm={true}
                    transfer={true}
                    width={200}
                    title={this.$t('common.confirmDelete')}
                    placement="top"
                    type="error"
                    vOn:on-ok={() => {
                      this.remove(params.row, 'edit')
                    }}
                    vOn:on-cancel={() => {}}
                  >
                    <Icon type="md-trash"></Icon>
                  </Poptip>
                </a>
              </div>
            )
          },
        },
      ],
      uploadModalVisible: false,
    }
  },

  created() {
    this.getFileList()
  },

  methods: {
    // get list
    getFileList() {
      this.loading = true
      getUploadFiles(this.nodeID)
        .then((res) => {
          if (res?.data) {
            this.fileList = res.data.map((item) => {
              return { name: item }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // remove file
    remove(row) {
      if (row?.name) {
        const nameStrings = row.name.split('/')
        const fileName = nameStrings[nameStrings.length - 1]
        deleteUploadFile(this.nodeID, fileName).then(() => {
          this.$Message.success(this.$t('common.deleteSuccess'))
          this.getFileList()
        })
      }
    },

    showUploadModal() {
      this.uploadModalVisible = true
    },
  },
}
</script>
